import script from "./fw26_admin_user_new.vue?vue&type=script&setup=true&lang=js"
export * from "./fw26_admin_user_new.vue?vue&type=script&setup=true&lang=js"

import "./fw26_admin_user_new.vue?vue&type=style&index=0&id=1e81ec48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e81ec48"]])

export default __exports__